/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-alert */
/* eslint-disable camelcase */
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AuthDecorator } from '@components/auth-decorator';
import { actions } from '@state/modals';
import { RootState } from '@state/store';
import { isActionActive } from '@utils/auctions';
import { Box, Button, Text } from '@versumstudios/ui';

interface IActionAuctionsComponent {
  seller: any;
  current_bid: any;
  current_bidder: any;
  auction_id: number;
  end_time: number;
}

export const ActionAuctionsComponent: FC<IActionAuctionsComponent> = ({
  seller,
  current_bid,
  current_bidder,
  auction_id,
  end_time,
}) => {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const viewer = auth.user?.id;
  const viewerIsBuyer = viewer === current_bidder?.user[0].user.id;
  const viewerIsSeller = viewer === seller.user[0].user.id;
  const auctionIsActive = isActionActive({ end_time });

  const handleCancel = () => {
    dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: 'auction-cancel', auctionId: auction_id } });
  };

  const handleWithdraw = () => {
    dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: 'auction-withdraw', auctionId: auction_id } });
  };

  const handleFinalize = () => {
    dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: 'auction-finalize', auctionId: auction_id } });
  };

  const handleAcceptCurrent = () => {
    dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: 'auction-accept-current', auctionId: auction_id } });
  };

  const handleBid = () => {
    dispatch({
      type: actions.MODALS_SET_MODAL,
      payload: {
        type: 'auction-bid',
        auctionId: auction_id,
        currentBid: current_bid,
        isMinBid: current_bidder === null,
      },
    });
  };

  return (
    <Box css={{ '&>*': { marginRight: '$space$4' } }}>
      {/* active and user isnt seller nor highest buyer */}
      {auctionIsActive && !viewerIsSeller && !viewerIsBuyer && (
        <AuthDecorator onClick={handleBid}>
          <Button variant="market">Bid</Button>
        </AuthDecorator>
      )}

      {/* active and user is highest bidder */}
      {auctionIsActive && viewerIsBuyer && (
        <Text unset css={{ color: '$secondaryFill', fontSize: 14 }}>
          You are the highest bidder
        </Text>
      )}

      {/* active user is seller and there's no bidder */}
      {auctionIsActive && viewerIsSeller && current_bidder === null && (
        <AuthDecorator onClick={handleCancel}>
          <Button variant="market">Cancel</Button>
        </AuthDecorator>
      )}

      {/* active user is seller and there's a bidder */}
      {auctionIsActive && viewerIsSeller && current_bidder !== null && (
        <AuthDecorator onClick={handleAcceptCurrent}>
          <Button variant="market">Accept current bid</Button>
        </AuthDecorator>
      )}

      {/* no longer active and user is buyer or seller */}
      {!auctionIsActive && (viewerIsBuyer || viewerIsSeller) && current_bidder !== null && (
        <AuthDecorator onClick={handleFinalize}>
          <Button variant="market">Finalize</Button>
        </AuthDecorator>
      )}
      {/* no longer active and user is buyer or seller */}
      {!auctionIsActive && viewerIsSeller && current_bidder === null && (
        <AuthDecorator onClick={handleWithdraw}>
          <Button variant="market">Withdraw</Button>
        </AuthDecorator>
      )}
    </Box>
  );
};
